const fpl = {
    title: "Building Low-Latency Order Books with Hybrid Binary-Linear Search Data Structures on FPGAs",
    year: "2023",
    description: "Published in 2023 33rd International Conference on Field-Programmable Logic and Applications (FPL)",
    link: "https://ieeexplore.ieee.org/abstract/document/10296447",
    keywords: ["FPGA", "High-Frequency Trading", "Order Book", "Binary Search"]
  };
  
  export default fpl;
  